import React from "react";
import { useState } from "react";
import { token, url } from "../../Functionalities/Config";
import { showMessage } from "../../Functionalities/Functions";
import axios from "axios";

function AdsSection({ data, refreshData }) {
  // alert("AdsSection ", JSON.stringify( data))
  const [Active, setActive] = useState(data.is_active == true ? true : false);
  const changeState = () => {
    var fdata = new FormData();
    fdata.append("keyword", "update_section_status");
    fdata.append("status", Active ? "false" : "true");
    fdata.append("section_id", data.id);

    // void 0

    var config = {
      method: "patch",
      url: url + "/items/sections/",
      headers: {
        Authorization: token,
      },
      data: fdata,
    };

    axios(config)
      .then((res) => {
        if (res.data.Status) {
          showMessage(
            "Status updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
          refreshData();
        } else {
          showMessage(
            "Status update failed",
            "danger",
            "Failed!",
            "top",
            "top-right",
            0,
          );
        }
      })
      .catch((err) => {
        showMessage(
          "Status update failed",
          "danger",
          "Failed!",
          "top",
          "top-right",
          0,
        );
      });
  };
  return (
    <>
      <div className="card m-0">
        <div className="card-header p-0">
          <h5 className="card-title mb-2">
            <img
              src={data.icon?.image}
              alt=""
              style={{ width: "2rem", height: "2rem", objectFit: "cover" }}
            />
            {window.location.pathname
              .toLowerCase()
              .includes("mobilelandingpage") && (
              <span>
                <i
                  class="fa fa-eye ml-2"
                  style={{ cursor: "pointer", color: "#EF4832" }}
                  onClick={() => (window.location.href = "/section/" + data.id)}
                />
              </span>
            )}
          </h5>
          <button
            className={
              Active
                ? "btn btn-xs btn-outline-primary "
                : "btn btn-xs btn-primary"
            }
            onClick={() => changeState()}
          >
            {Active ? "Disable" : "Activate"}
          </button>
        </div>

        <div className="card-body p-0">
          <div className="basic-list-group">
            <div className="list-group">
              <div className="list-group-item list-group-item-action flex-column align-items-start p-0">
                <div>
                  <div className="d-flex align-items-center ">
                    <div className="list-group-item list-group-item-action flex-column align-items-start px-0 py-3">
                      <div className="d-flex align-items-center">
                        <div>
                          <img
                            src={data.icon?.image}
                            alt=""
                            style={{
                              width: "100%",
                              objectFit: "cover",
                              borderRadius: ".5rem",
                            }}
                          />
                        </div>

                        <div className="ml-2">
                          <div className="d-flex w-100 justify-content-between">
                            <h6 className="mb-1 text-black">{data.heading}</h6>
                          </div>
                          {/* <p className="mb-1">{item.content}</p> */}
                          <small className="text-muted">{data.desc}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdsSection;
